import css from './displayTemplate.module.scss';

import { Fragment, memo } from 'react';

import { parseWordTemplate, prettifyText } from 'core/helpers/text';

type TProps = {
  children: string;
};
const DisplayTemplate: React.FC<TProps> = ({ children }) => (
  <>
    {parseWordTemplate(children).map((item, idx) => (
      <Fragment key={idx}>
        {item.type === 'text' && prettifyText(item.text)}
        {item.type === 'highlight' && (
          <span className={css.highlight}>{prettifyText(item.text)}</span>
        )}
      </Fragment>
    ))}
  </>
);

export default memo(DisplayTemplate);
